const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-8 bg-card">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <a href="#" className="text-xl font-bold text-primary">
              Yankoua<span className="text-accent"> Ivan</span>
            </a>
          </div>

          <div className="text-center md:text-right">
            <p className="text-foreground/70">
              &copy; {currentYear} Yankoua Ivan. Tous droits réservés.
            </p>
            <p className="text-foreground/50 text-sm mt-1">
              Développeur Fullstack Node.js
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
